<script setup lang="ts">
/** DR-09 · Promote a revision: live traffic moves to it, while the address stays unchanged. */
import Dialog from '~/components/ui/Dialog.vue'
import Icon from '~/components/ui/Icon.vue'
import ActionButton from '~/components/ui/ActionButton.vue'

interface RevisionFacts { number: string; model: string; version: string | null; created?: string }
defineProps<{ endpoint: string; revision: RevisionFacts; live: RevisionFacts | null }>()
const emit = defineEmits<{ close: []; confirm: [] }>()
</script>

<template>
  <Dialog title="Promote revision" :meta="endpoint" :width="480" @close="emit('close')">
    <template #icon><Icon name="undo" /></template>
    <div class="grid grid-cols-2 gap-2.5">
      <div class="rounded-md border border-border px-3 py-2.5">
        <div class="mb-1.5 text-[length:var(--type-meta)] font-semibold text-muted-foreground">Serving now</div>
        <template v-if="live">
          <div class="text-xs font-medium">Revision {{ live.number }}</div>
          <div class="num text-[length:var(--type-fine)] text-muted-foreground">{{ live.model }}<template v-if="live.version"> v{{ live.version }}</template></div>
        </template>
        <div v-else class="text-xs text-muted-foreground">No revision</div>
      </div>
      <div class="border-gradient-primary rounded-md px-3 py-2.5">
        <div class="mb-1.5 text-[length:var(--type-meta)] font-semibold text-primary">Promote</div>
        <div class="text-xs font-medium">Revision {{ revision.number }}</div>
        <div class="num text-[length:var(--type-fine)] text-muted-foreground">{{ revision.model }}<template v-if="revision.version"> v{{ revision.version }}</template><template v-if="revision.created"> · {{ revision.created }}</template></div>
      </div>
    </div>
    <p class="m-0 text-xs leading-relaxed text-muted-foreground">Live traffic moves to revision {{ revision.number }}. The address stays the same<template v-if="live">; revision {{ live.number }} stays in the timeline and can be promoted again</template>.</p>
    <template #actions>
      <ActionButton label="Cancel" @click="emit('close')" />
      <ActionButton label="Promote" variant="primary" @click="emit('confirm')"><template #icon><Icon name="undo" /></template></ActionButton>
    </template>
  </Dialog>
</template>
